/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDeletedEntity
 */
export interface ControlDeletedEntity {
    /**
     * 
     * @type {string}
     * @memberof ControlDeletedEntity
     */
    entity_id?: string;
}

/**
 * Check if a given object implements the ControlDeletedEntity interface.
 */
export function instanceOfControlDeletedEntity(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlDeletedEntityFromJSON(json: any): ControlDeletedEntity {
    return ControlDeletedEntityFromJSONTyped(json, false);
}

export function ControlDeletedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDeletedEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
    };
}

export function ControlDeletedEntityToJSON(value?: ControlDeletedEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
    };
}

